import _ from 'lodash';
import moment from 'moment';

import Assignee from './assignee';
import Attachment from './attachment';
import createModel, { prop } from './lib/create_model';
import { CustomAttributeValue, customAttributeValuesFromDto } from 'models/custom_attribute';
import htmlToText from './conversation_item/html_to_text';
import Mention from './mention';
import redactAttachment from './attachment_redact';
import ServerClock from 'scripts/application/lib/server_clock';

const Task = createModel({
  modelName: 'Task',

  properties: {
    assignee: Assignee,
    attachments: [Attachment],
    bodyHtml: String,
    closedAt: String,
    customAttributes: prop([CustomAttributeValue]).default([]),
    dueAt: String,
    hasNotifiedDue: Boolean,
    mentions: [Mention],
    note: String,
    topicIds: prop([String]).default([]),
    updatedAt: String,
  },

  isClosed() {
    return !!this.closedAt;
  },

  markClosed() {
    let time = ServerClock.toISOString();
    this.closedAt = time;
    this.updatedAt = time;
  },

  markAsOpen() {
    this.closedAt = null;
    this.updatedAt = ServerClock.toISOString();
  },

  assign(assignee) {
    this.assignee = assignee;
    this.updatedAt = ServerClock.toISOString();
  },

  // Topic/attribute edits deliberately leave updatedAt alone: it drives inbox
  // ordering and due-notification state, neither of which a topic change should
  // disturb.
  applyTopicChanges({ add, remove }) {
    this.topicIds = _.difference(_.union(this.topicIds, add), remove);
  },

  applyCustomAttributeChanges({ add, remove }) {
    const equalAttrs = (a, b) => a.id === b.id && a.value === b.value;
    const customAttributes = _.unionWith(this.customAttributes, customAttributeValuesFromDto(add), equalAttrs);
    this.customAttributes = _.differenceWith(customAttributes, remove, equalAttrs);
  },

  redactAttachment(id) {
    redactAttachment(this.attachments, id);
  },

  getMessageText() {
    return this.note;
  },

  statics: {
    create(attrs) {
      if (!attrs.note) {
        attrs = {
          ...attrs,
          note: htmlToText(attrs.bodyHtml),
        };
      }

      return new this(
        _.assign(
          {
            updatedAt: ServerClock.toISOString(),
            hasNotifiedDue: !moment(ServerClock.now()).isBefore(attrs.dueAt),
          },
          attrs
        )
      );
    },
  },
});

export default Task;
